import { useCallback } from 'react';

/**
 * Hook for new car related functionality
 * - Dealership display name mapping
 */
const useNewCar = () => {
  const getDealershipDisplayName = useCallback(
    (locationNameOrCity: string, fallbackCity?: string): string => {
      // prettier-ignore
      const dealershipMap: Record<string, string> = {
        'Atlanta': 'Carvana Atlanta',
        'Casa Grande': 'Carvana Casa Grande',
        'Park Cities': 'Carvana Park Cities',
        'Sacramento': 'Carvana Sacramento',
        'San Diego': 'Carvana San Diego',
        'Boston': 'Carvana Boston',
        'Avon Lake': 'Carvana Avon Lake',
      };

      const match = Object.keys(dealershipMap).find(key => locationNameOrCity.includes(key));

      if (match) {
        return dealershipMap[match];
      }

      return fallbackCity ? `${fallbackCity} pickup location` : 'Carvana pickup location';
    },
    []
  );

  return { getDealershipDisplayName };
};

export default useNewCar;
